export const TEST_ID = 'banner';
